import React from 'react'
import './HomeApplication.scss'
import HomeApplicationForm from './HomeApplicationForm/HomeApplicationForm'

/*
  Заголовок слева, форма справа; подложка во всю ширину, как у
  «Подключения» и «Услуг для дома». Раньше полоса была тёмной, но
  сразу под ней идёт тёмный подвал и две полосы читались как одна.
*/
const HomeApplication = () => {
  return (
    <div className='homeApplication_container' id='homeContact'>
      <div className="homeApplication_block">
        <div className="homeApplication_card">
          <div className="homeApplication_title">
            <h2>Оставьте заявку на подключение</h2>
            <p>Мы перезвоним вам в течении 24 часов</p>
          </div>
          <div className="homeApplication_item">
            <HomeApplicationForm />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeApplication
